import { useLocation } from 'react-router-dom';

/**
 * Hook to check if the current normalized pathname equals the provided target path.
 * Accepts a single target path (absolute, including locale if needed).
 */
export const useIsCurrentPath = (targetPath?: string) => {
  const location = useLocation();

  if (!targetPath) return false;

  const normalize = (p: string) => p.split('?')[0].replace(/\/$/, '');

  const currentPath = normalize(location.pathname);
  const expected = normalize(targetPath);

  return currentPath === expected;
};

export default useIsCurrentPath;
